"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = void 0;
exports.shadows = {
    $4dp: "0 4px 10px 0 rgba(69, 84, 94, 0.1)",
    $8dp: "0 8px 16px 0 rgba(69, 84, 94, 0.1)",
    $12dp: "0 12px 24px 0 rgba(69, 84, 94, 0.1)",
    $16dp: "0 16px 32px 0 rgba(69, 84, 94, 0.1)",
};
//# sourceMappingURL=index.js.map